import { WORKSUITE_TENANT_DOMAIN } from './constants';

/**
 * Worksuite serves images as tenant-relative paths (e.g. /logos/vendor-logo/...)
 * or protocol-relative URLs (e.g. //thehomedepot.worksuite.com/...). External
 * sources like an SSO provider's profile picture are already absolute URLs and
 * must be left untouched.
 * @param {string} url
 * @returns {string}
 */
export function resolveWorksuiteImageUrl(url) {
  if (!url) {
    return url;
  }
  if (url.startsWith('//')) {
    return `https:${url}`;
  }
  if (url.startsWith('/')) {
    return `https://${WORKSUITE_TENANT_DOMAIN}${url}`;
  }
  return url;
}
